import React, { useMemo } from 'react';
import { Alert, Spin, Input, Select } from "antd";
import { useForm, FormProvider } from 'react-hook-form';
import { useDispatch, useSelector } from "react-redux";
import * as actionCreators from "../../store/actions/index";
import Enums from '../../shared/enums';
import Form from '../Form/Form';
import FormItem from '../FormItem/FormItem';
import FormButtons from '../FormButtons/FormButtons';
import { isNullOrUndefined, isObjectNotEmpty } from '../../shared/objectUtils';

const { TextArea } = Input;

const NewNote = ({ noteEntityType, noteEntityId, cancel }) => {
    const methods = useForm({ mode: 'all', reValidateMode: 'onChange', criteriaMode: 'all', shouldFocusError: true, shouldUnregister: true });

    const dispatch = useDispatch();
    const userEntityType = useSelector(state => state.auth.entityType);
    const isLoading = useSelector(state => state.notes.isRecordAddLoading);
    const error = useSelector(state => state.notes.addRecordError);

    const noteVisibilityOptions = Enums.NoteVisibilities.selectListOptions();

    const onSubmit = (data) => {
        data.entityId = noteEntityId;
        data.entityType = noteEntityType;

        if (isNullOrUndefined(data.visibleTo)) {
            data.visibleTo = userEntityType;
        }

        if (isObjectNotEmpty(data)) {
            dispatch(actionCreators.addNote(data));
        } else {
            onCancel();
        }
    };

    const onCancel = () => {
        dispatch(actionCreators.addNoteCancel());
        cancel();
    };

    useMemo(() => {
        // clear any previous errors if this is a new form
        dispatch(actionCreators.addNoteErrorClear());
    }, []);

    useMemo(() => {
        if (isLoading !== null && isLoading === false && error === null) {
            onCancel();
        }
    }, [isLoading, error]);

    const formItemLayout = {
        labelCol: { span: 8 },
        wrapperCol: { span: 16 },
    };

    return (
        <FormProvider {...methods}>
            <Form onSubmit={methods.handleSubmit(onSubmit)}>
                <Spin style={{ height: '100%', width: '100%' }} size="large" spinning={isLoading === true && error === null}>
                    <FormItem {...formItemLayout} label="Note" required
                        render={({ onChange, onBlur, value, name, ref }) => <TextArea onBlur={onBlur} onChange={e => { onChange(e.target.value); }} value={value} name={name} autoSize={{ minRows: 8 }} ref={ref} />}
                        rules={{ required: 'Required Field' }}
                        name="body"
                    />
                    {userEntityType === "STAFF" ? (
                        <FormItem {...formItemLayout} label="Who can see this note?" required
                            render={({ onChange, onBlur, value, name, ref }) => (
                                <Select
                                    placeholder="Please Select the Visibility Level"
                                    allowClear={true}
                                    style={{ width: '100%' }}
                                    virtual={false}
                                    onBlur={onBlur}
                                    onChange={(selected) => { onChange(selected); }}
                                    value={value}
                                    name={name}
                                    ref={ref}
                                >
                                    {noteVisibilityOptions}
                                </Select>
                            )}
                            rules={{ required: 'Required Field' }}
                            name="visibleTo"
                        />
                    ) : null}
                    {error && <Alert message={`${error}`} type="error" />}
                </Spin>
                <FormButtons cancel={onCancel} disabled={isLoading === true && error === null} submitText="Create Note" />
            </Form>
        </FormProvider>
    );
};

export default NewNote;